import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'

function getListNftBuy(cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${BASE_API_LIVE_SWAP}/nft-stake`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp?.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('getListNftBuy', error)
  }

  return null
}

export default getListNftBuy
